export function generateRandomKey() {
  // Get current timestamp
  const timestamp = new Date().getTime();

  // Generate a random number
  const randomNumber = Math.floor(Math.random() * 1000);

  // Combine timestamp and random number to create a unique key
  const randomKey = `${timestamp}-${randomNumber}`;

  return randomKey;
}

export function generateUniqueRandomKey() {
  const timestamp = new Date().getTime();
  const uuid = crypto.randomUUID();
  return `${timestamp}-${uuid}`;
}